import { render, staticRenderFns } from "./MailFormFeedback.vue?vue&type=template&id=2f13eb3d"
import script from "./MailFormFeedback.vue?vue&type=script&lang=js"
export * from "./MailFormFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports